module.exports = __webpack_public_path__ + "media/images/what_can_do_1-3c6c41b7f5b16ced77465bb594d99674.svg";